(() => {
  const article = document.querySelector('.article-template__content');
  const toc = document.querySelector('.article-template__toc');
  const links = document.querySelector('.article-template__toc-links');
  if (!article || !toc || !links) return;

  const sentenceCase = (value) => {
    const text = value.trim();
    if (!text || text !== text.toLocaleUpperCase('es')) return text;
    const lower = text.toLocaleLowerCase('es');
    return lower.charAt(0).toLocaleUpperCase('es') + lower.slice(1);
  };

  [...article.querySelectorAll(':scope > p')].forEach((paragraph) => {
    paragraph.classList.remove('MsoNormal');
    if (!paragraph.textContent.replace(/\u00a0/g, ' ').trim() && !paragraph.querySelector('img')) paragraph.remove();
  });

  const directH2 = [...article.querySelectorAll(':scope > h2')];
  const directH3 = [...article.querySelectorAll(':scope > h3')];
  if (directH2.length <= 1 && directH3.length >= 3) {
    directH3.forEach((heading) => {
      const replacement = document.createElement('h2');
      [...heading.attributes].forEach(({ name, value }) => replacement.setAttribute(name, value));
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });
  }

  [...article.querySelectorAll('h2, h3')].forEach((heading) => {
    heading.textContent = sentenceCase(heading.textContent);
  });

  const firstParagraph = article.querySelector(':scope > p');
  if (firstParagraph) {
    const cleanText = firstParagraph.textContent.replace(/\s+/g, ' ').trim();
    if (cleanText.length > 520 && !firstParagraph.children.length) {
      const stops = [...cleanText.matchAll(/[.!?](?:\s|$)/g)]
        .map((match) => match.index + 1)
        .filter((position) => position >= 220);
      const splitAt = stops.find((position) => position <= 420) || stops[0];
      if (splitAt && splitAt < cleanText.length - 80) {
        const continuation = document.createElement('p');
        firstParagraph.textContent = cleanText.slice(0, splitAt).trim();
        continuation.textContent = cleanText.slice(splitAt).trim();
        firstParagraph.after(continuation);
      }
    }
    firstParagraph.classList.add('article-template__lead');
  }

  [...article.children].forEach((element, index) => {
    const image = element.matches('img') ? element : element.querySelector('img');
    if (image) {
      element.classList.add('article-template__media-block');
      element.classList.add(index % 2 ? 'article-template__media-block--right' : 'article-template__media-block--left');
      image.loading = index < 4 ? 'eager' : 'lazy';
      image.decoding = 'async';
      const setEditorialWidth = () => {
        if (!image.naturalWidth) return;
        const width = Math.min(Math.max(Math.round(image.naturalWidth * 1.1), 360), 680);
        element.style.setProperty('--article-media-max', `${width}px`);
        element.style.setProperty('max-width', `${width}px`, 'important');
      };
      if (image.complete) setEditorialWidth();
      else image.addEventListener('load', setEditorialWidth, { once: true });
    }

    if (element.tagName === 'P') {
      const value = element.textContent.trim();
      const step = value.match(/^Paso\s+(\d+)\s*:\s*/i);
      const numbered = value.match(/^([1-9])\.\s+/);
      if (step) {
        element.classList.add('article-template__step');
        element.dataset.step = step[1];
      } else if (numbered) {
        element.classList.add('article-template__numbered-point');
        element.dataset.number = numbered[1];
      }
    }
  });

  [...article.querySelectorAll(':scope > p')].forEach((paragraph) => {
    if (paragraph.previousElementSibling?.classList.contains('article-template__media-block') && paragraph.querySelector('strong')) {
      paragraph.classList.add('article-template__product-note');
    }
  });

  if (!document.querySelector('.article-template__hero-container')) {
    const firstMedia = article.querySelector('.article-template__media-block');
    const firstImage = firstMedia?.matches('img') ? firstMedia : firstMedia?.querySelector('img');
    const header = document.querySelector('.article-template__header');
    if (firstImage && firstMedia && header) {
      const heroContainer = document.createElement('div');
      heroContainer.className = 'article-template__hero-container article-template__hero-container--generated';
      const hero = document.createElement('div');
      hero.className = 'article-template__hero-image article-template__hero-large media';
      hero.appendChild(firstImage);
      heroContainer.appendChild(hero);
      header.insertAdjacentElement('afterend', heroContainer);
      if (firstMedia !== firstImage) firstMedia.remove();
    }
  }

  const faqHeading = [...article.querySelectorAll('h2')].find((heading) => heading.textContent.trim().toLocaleLowerCase('es').includes('preguntas frecuentes'));
  if (faqHeading) {
    faqHeading.classList.add('article-template__faq-heading');
    let cursor = faqHeading.nextElementSibling;
    while (cursor && cursor.tagName !== 'SCRIPT') {
      if (cursor.tagName === 'H3' && cursor.nextElementSibling?.tagName === 'P') {
        const answer = cursor.nextElementSibling;
        const next = answer.nextElementSibling;
        const details = document.createElement('details');
        details.className = 'article-template__faq-item';
        const summary = document.createElement('summary');
        const question = document.createElement('span');
        question.textContent = cursor.textContent;
        const icon = document.createElement('span');
        icon.className = 'article-template__faq-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '+';
        summary.append(question, icon);
        details.append(summary, answer);
        cursor.replaceWith(details);
        cursor = next;
      } else {
        cursor = cursor.nextElementSibling;
      }
    }
  }

  const headingCandidates = [...article.querySelectorAll('h2, h3')]
    .filter((heading) => !heading.closest('.article-template__faq-item'))
    .filter((heading) => heading.textContent.trim())
    .slice(0, 8);
  const headings = headingCandidates;
  if (headings.length >= 2) {
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `seccion-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      links.appendChild(link);
    });
    toc.hidden = false;
  }

  const tocToggle = toc.querySelector('.article-template__toc-toggle');
  tocToggle?.addEventListener('click', () => {
    const expanded = tocToggle.getAttribute('aria-expanded') === 'true';
    tocToggle.setAttribute('aria-expanded', String(!expanded));
    toc.classList.toggle('is-open', !expanded);
  });

  const progress = document.querySelector('.article-template__reading-progress span');
  const updateProgress = () => {
    if (!progress) return;
    const rect = article.getBoundingClientRect();
    const total = Math.max(article.offsetHeight - window.innerHeight * 0.45, 1);
    const read = Math.min(Math.max(-rect.top + window.innerHeight * 0.3, 0), total);
    progress.style.transform = `scaleX(${read / total})`;
  };
  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
})();
